app.mediator.registerModule(MODULE_NAME__ENTER_FORM, function (app) {

    var dataStore = app.data;
    var helpers = app.helpers.funcs;
    var teamVal = 'Team';
    var individualVal = 'Individual';
    var allowedEmailValues = [];
    var usingSubmitConstraints = false;
    var emailCheckTimeout = {};
    var filesAreBeingUploaded = false;
    var teamMembersListInputsTouched = false;
    var autosaveEnabled = true;

    var auxLanguageValidationRules = {
        'projectNameAlternateLanguage': ['present', 'maxLength'],
        'projectDescriptionAlternateLanguage': ['present', 'maxLength'],
        'whatItDoesAlternateLanguage': ['present', 'maxLength'],
        'yourInspirationAlternateLanguage': ['present', 'maxLength'],
        'howItWorksAlternateLanguage': ['present', 'maxLength'],
        'designProcessAlternateLanguage': ['present', 'maxLength'],
        'howIsItDifferentAlternateLanguage': ['present', 'maxLength'],
        'futurePlansAlternateLanguage': ['present', 'maxLength'],
        'awardsAlternateLanguage': ['present', 'maxLength'],
        'imageCaption-1-AlternateLanguage': ['present', 'maxLength', 'requiresField'],
        'imageCaption-2-AlternateLanguage': ['maxLength', 'requiresField'],
        'imageCaption-3-AlternateLanguage': ['maxLength', 'requiresField'],
        'imageCaption-4-AlternateLanguage': ['maxLength', 'requiresField'],
        'imageCaption-5-AlternateLanguage': ['maxLength', 'requiresField']
    };

    return {

        // The jQuery DOM element that is the register form
        $formElem: null,

        // The JDA validator object - a wrapper around validateJS. Created on init().
        jdaValidator: null,

        isDomLoaded: false,

        saveDraftConstraints: null,
        submitConstraints: null,

        // When the alternate language dropdown has this value, this script will consider
        // there to be no alternate language
        defaultLanguageValueForDropdown: '',

        // When the language select toggle-button-group  has this value, this script
        // will consider the default language (english) to be selected.
        defaultLanguageValueForBtnGroup: 'en',

        // This is a fallback that will be overridden.
        filesAreBeingUploadedMessage: 'Cannot save form, as files are currently being uploaded. Please wait for the files to finish uploading.',

        isSubmitting: false,
        hasEditingRights: true,
        formId: "",
        autoSaveIntervalId: null,

        //==========================================================xdiv2====
        // Start and stop
        //===================================================================

        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
                this.isDomLoaded = true;
            }
        },

        init: function () {

            // Init
            var scope = this;

            // Prepare data for creation of jda validator instance
            this.saveDraftConstraints = dataStore.get('validation.enterFormSaveDraft');
            this.submitConstraints = dataStore.get('validation.enterFormSubmit');
            this.$formElem = $('.page-edit-entry form');

            // Don't bother to add the event listeners if the form DOM element does not exist
            // i.e. We are on another page. This will save memory.
            if (!this.$formElem.length) return;

            // Create jda validator instance
            this.jdaValidator = app.validator.build({}, this.$formElem);

            scope.addEventListeners();
            scope.addMediatorListeners();
            scope.useSaveDraftConstraints(false);
            scope.changeMultiTeamMemberConstraintsSeverity(false);
            scope.reactToLanguageDropdown();
            scope.reactToLanguageBtnGroup();
            scope.conditionallyStick();
            scope.lockFormEditing();
            scope.initAutoSave();

            this.$formElem.on(EVENT_NAME__ENTER_FORM__LANGUAGE_STRINGS_SET_FOR_THE_FIRST_TIME, function () {

                scope.preEmptivelyInspectEmails(function () {
                    if (scope.getEntryOperationType() == 'edit') {
                        scope.evaluateForm(false, false);
                    }
                });
            });

            scope.updateFormId();

            var $teamMemberInputs = $('input[data-validation-name=teamMembers]');
            $teamMemberInputs.change(function () {
                $teamMemberInputs.each(function (k, teamMemberInput) {
                    if ($(teamMemberInput).val()) {
                        teamMembersListInputsTouched = true;
                        scope.changeMultiTeamMemberConstraintsSeverity();
                    }
                });
            });

            this.$formElem.submit(function (e, options) {
                scope.handleFormSubmit(e, options);
            });

            app.mediator.notify(EVENT_NAME__ENTER_FORM__INITIATED);
        },

        //==========================================================xdiv2====
        // Mediator event listeners
        //===================================================================

        addMediatorListeners: function () {
            var scope = this;

            app.mediator.addListener(EVENT_NAME__UPLOAD_IMAGES_CAPTIONS__CARDS_REORDERED, function (data) {
                scope.refreshFileCache();
                if (!data.eventWasBroadcastOnInitOfUploadImagesCaptionsModule) {
                    scope.evaluateForm(false);
                }
            }, this);

            app.mediator.addListener(EVENT_NAME__UPLOAD_IMAGES_CAPTIONS__FILE_UPLOAD_STARTED, function () {
                filesAreBeingUploaded = true;
            }, this);

            app.mediator.addListener(EVENT_NAME__UPLOAD_IMAGES_CAPTIONS__FILE_UPLOAD_COMPLETE, function () {
                filesAreBeingUploaded = false;
            }, this);

            app.mediator.addListener(EVENT_NAME__CONFIRM_ENTRY_SUBMIT__CONFIRM_BUTTON_TRIGGERED, function () {
                scope.$formElem.submit();
            }, this);

            app.mediator.addListener(EVENT_NAME__CONFIRM_ENTRY_SUBMIT__SAVE_BUTTON_TRIGGERED, function () {
                $('#save-nav .li-save').trigger('click');
            }, this);

            app.mediator.addListener(EVENT_NAME__UPLOAD_IMAGES_CAPTIONS__FILE_REMOVED, function (data) {
                scope.evaluateForm(false, undefined, data.$cardCol);
            });

            app.mediator.addListener(EVENT_NAME__CONFIRM_ENTRY_SUBMIT__MODAL_CLOSED, function () {
                scope.$formElem.find('#submitEntryButton').focus();
            });
        },

        //==========================================================xdiv2====
        // DOM event listeners
        //===================================================================

        addEventListeners: function () {

            var scope = this;

            app.globalEventRegistry.addListener('resize', function () {
                scope.conditionallyStick();
            });
            app.globalEventRegistry.addListener('scroll', function () {
                scope.conditionallyStick();
            });

            this.$formElem.on('keyup', 'input[data-validation-name=teamMembers]', function (e) {
                if (scope.jdaValidator.configuration.keyUpShouldBeIgnored(e)) return;
                if (!teamMembersListInputsTouched) {
                    teamMembersListInputsTouched = true;
                }
            });

            this.$formElem.on('keyup', 'input[type=password], input[type=text], input[type=email], textarea', function (e) {
                if (scope.jdaValidator.configuration.keyUpShouldBeIgnored(e)) return;
                if ($(this).data('validation-name') == 'teamMembers') return; // Validation of team members listener is defined below.
                if ($(this).data('validation-name') == 'projectName') {
                    app.mediator.notify(EVENT_NAME__ENTER_FORM__PROJECT_NAME_CHANGED, {
                        newProjectName: $(this).val()
                    });
                }
                var $elem = $(this);
                scope.evaluateElement($elem);
            });

            this.$formElem.find('select, input[type=checkbox], input[type=radio]').change(function () {
                var $elem = $(this);
                scope.evaluateElement($elem);
            });

            this.$formElem.find('input[type=file]').on('uploadImagesCaptions.filesSet', function (e, data) {
                var $elem = $(this);
                var formFieldId = scope.jdaValidator.configuration.getFormFieldId($elem);
                scope.jdaValidator.cacheValuesForFormField(formFieldId, data.files);
                scope.evaluateElement($elem);
            });

            this.$formElem.on('keypress', 'input[type=text], input[type=email], input[type=tel]', function (e) {
                if (e.keyCode == 13) { // Enter key
                    e.preventDefault();
                }
            });

            $('#save-nav .li-cancel').click(function (e) {
                var disabled = $(this).hasClass('disabled');
                if (!disabled) {
                    scope.putLoadIndicatorOnBtn($(this));
                }
                app.mediator.notify(EVENT_NAME__ENTER_FORM__CANCEL_PRESSED, {
                    buttonIsDisabled: disabled
                });
            });

            $('#save-nav .li-save').on('click', function (e) {
                if ($(this).hasClass('disabled')) {
                    e.preventDefault();
                    return false;
                };

                autosaveEnabled = false;

                app.helpers.funcs.loadifyButtons($(this), true);
                $("#submitField").val("false");
                $("#previewField").val("false");
                scope.useSaveDraftConstraints();
                scope.evaluateForm(true, true);
            });

            $('#save-nav .li-preview').on('click', function (e) {
                if ($(this).hasClass('disabled')) {
                    e.preventDefault();
                    return false;
                };

                autosaveEnabled = false;

                scope.putLoadIndicatorOnBtn($(this));
                $("#submitField").val("false");
                $("#previewField").val("true");
                scope.useSaveDraftConstraints();
                scope.evaluateForm(true, true);
            });

            $('#save-nav .li-submit').on('click', function (e) {
                if ($(this).hasClass('disabled')) {
                    e.preventDefault();
                    return false;
                };
                scope.putLoadIndicatorOnBtn($(this));
                $("#submitField").val("true");
                $("#previewField").val("false");
                scope.useSubmitConstraints();
                scope.evaluateForm(true, true);
            });

            $('#save-nav button').on('click', function (e) {
                e.preventDefault();
            });

            this.$formElem.on('click', 'a.disabled, a[disabled]', function (e) {
                e.preventDefault();
            });

            this.$formElem.find('input[data-validation-name=entryType]').change(function () {
                scope.changeMultiTeamMemberConstraintsSeverity(teamMembersListInputsTouched);
                var val = $('input[data-validation-name=entryType]:checked').val();
                if (val == teamVal) {
                    $('.team').removeClass('hide').addClass('show');
                } else {
                    $('.team').removeClass('show').addClass('hide');
                }
            });

            // When the email address input changes, ask the server if it is valid.
            // If not, add the address to a list of invalid values, within the form constraints object.
            // Gate the AJAX call to once every 500ms.
            var emailElemSelector = 'input[data-validation-name=teamMembers]';
            var $emailElem = scope.$formElem.find(emailElemSelector);
            var emailElemId = scope.jdaValidator.configuration.getFormFieldId($emailElem);
            this.$formElem.on('change keyup', emailElemSelector, function (e) {
                if (scope.jdaValidator.configuration.keyUpShouldBeIgnored(e)) return;
                scope.validateTeamMemberInput(this);
            });

            this.$formElem.find('select[name=alternateLanguageCode]').change(function () {
                scope.reactToLanguageDropdown();
            });
            this.$formElem.find('.language-btn-group input').change(function () {
                scope.reactToLanguageBtnGroup($(this).val());
            });

            window.addEventListener("pageshow", function () {
                var alreadyPreviewed = $('#entryWasPreviewedField').val() == 'true';
                var newEntry = $('input[name=id]:hidden').val() == '';

                // to prevent browser back button issues ensure new entry form is cleared
                if (newEntry && !alreadyPreviewed) {
                    scope.resetForm();
                }
            });

            scope.initEntryCategoryLabelAccessibility();
        },

        initEntryCategoryLabelAccessibility: function () {
            $(document).on('keydown', '.entry-category-label', function (e) {
                if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
                    e.preventDefault();

                    var $label = $(this);
                    var $input = $label.find('input[type="checkbox"]');

                    if ($input.length) {
                        $input.prop('checked', !$input.prop('checked')).trigger('change');

                        if ($input.prop('checked')) {
                            $label.addClass('active');
                        } else {
                            $label.removeClass('active');
                        }
                    }
                }
            });
        },

        disableSubmitUi: function () {
            var $btns = $('#save-nav .jda-save-nav-right li');
            app.helpers.funcs.loadifyButtons($btns);
            app.mediator.notify(EVENT_NAME__ENTER_FORM__SUBMIT_UI_DISABLED);
        },

        enableSubmitUi: function () {
            var $btns = $('#save-nav .jda-save-nav-right li');
            app.helpers.funcs.deloadifyButtons($btns, true);
            app.mediator.notify(EVENT_NAME__ENTER_FORM__SUBMIT_UI_ENABLED);
        },

        //==========================================================xdiv2====
        // DOM event handlers: Triggering validation
        //===================================================================

        handleFormSubmit: function (e, options) {
            var scope = this;
            options = options || {};

            if (!options.formChecked) {
                e.preventDefault();

                $.get('/umbraco/api/entryapi/serviceavailable',
                    function (response) {
                        if (response.success) {

                            var documentIds = [];
                            var documentIdInputs = $(".document-id-input");
                            for (var i = 0; i < documentIdInputs.length; i++) {
                                var documentId = documentIdInputs[i].value;
                                if (documentId !== "") {
                                    documentIds.push(documentId);
                                }
                            }

                            helpers.validateDocuments(
                                documentIds,
                                function () {
                                    scope.doSave(e);
                                },
                                EVENT_NAME__ENTER_FORM__IMAGE_DOESNT_EXIST,
                                window.serverData.generalLanguageStrings.imagesNeedReUploadingToastmessage);

                        } else {
                            app.ui.uiPlugins.toast.fire(window.serverData.generalLanguageStrings.serverUnavailableMessage, 'danger');
                            return;
                        }
                    })
                    .fail(function () {
                        app.ui.uiPlugins.toast.fire(window.serverData.generalLanguageStrings.serverUnavailableMessage, 'danger');
                        return;
                    });
            }
        },

        updateFormId: function () {
            var scope = this;

            this.disableSubmitUi();

            scope.formId = $('#entryPageContainer').data('entry-id');
            document.getElementById('formIdInput').value = scope.formId;
            scope.saveFormDraft().then(response => {
                if (response.success) {
                    scope.formId = response.result.id;
                    formIdInput.value = scope.formId;

                    scope.hydrateNewImageIds(response);
                }
            }).finally(() => {
                this.enableSubmitUi();
            });
        },

        doSave: function (e) {
            var scope = this;
            var messageBag = scope.jdaValidator.getMessageBag();
            scope.jdaValidator.presenter.clearStatuses();
            scope.jdaValidator.presenter.showStatuses(messageBag);
            if (messageBag.hasErrorMessages()) {
                scope.disableSubmitUi();
                scope.jdaValidator.presenter.scrollToFirstError(function () {
                    scope.enableSubmitUi();
                });
            } else {
                scope.stopAutoSave();
                $(e.currentTarget).trigger('submit', { 'formChecked': true });
            }
        },

        conditionallyStick: function () {
            var formBottom = this.$formElem.position().top + this.$formElem.offset().top + this.$formElem.outerHeight(true);
            var scrollBottom = $(window).scrollTop() + $(window).height();
            var $saveNav = $('.save-nav');
            var saveNavHeight = $saveNav.height();
            if (formBottom < scrollBottom) {
                $saveNav.removeClass('sticky-navbar');
            } else {
                $saveNav.addClass('sticky-navbar');
            }
        },

        evaluateForm: function (submitIfValid, scrollIfInvalid, $cardCol) {
            var scope = this;

            this.passAllowedEmailValues();
            submitIfValid = ((typeof submitIfValid !== 'undefined') || submitIfValid === null) ? submitIfValid : true;
            scrollIfInvalid = ((typeof scrollIfInvalid !== 'undefined') || scrollIfInvalid === null) ? scrollIfInvalid : false;

            if (typeof $cardCol !== 'undefined') {
                var $fileInput = $cardCol.find('input[type=file]');
                if ($fileInput.length) {
                    var formFieldIdToClear = $fileInput.data('validation-name');
                    this.jdaValidator.clearCachedValuesForFormField(formFieldIdToClear);
                }
            }

            var messageBag = this.jdaValidator.getMessageBag();
            this.jdaValidator.presenter.clearStatuses();
            this.jdaValidator.presenter.showStatuses(messageBag);
            if (messageBag.hasErrorMessages() && scrollIfInvalid) {
                var $firstBadElem = this.jdaValidator.presenter.getFirstBadElem();
                if (!$firstBadElem.is(':visible')) {
                    scope.switchLanguageToRevealFirstBadElem($firstBadElem);
                }
                scope.disableSubmitUi();
                this.jdaValidator.presenter.scrollToFirstError(function () {
                    scope.enableSubmitUi();
                });
            }
            if ((!messageBag.hasErrorMessages()) && submitIfValid) {
                if (filesAreBeingUploaded) {
                    var toast = app.ui.uiPlugins.toast;
                    toast.fire(scope.filesAreBeingUploadedMessage);
                } else {
                    if (usingSubmitConstraints) {
                        // The user is trying to submit their entry for approval.
                        // Send a message to the mediator (so that the confirmEntrySubmit.js module can show the lightbox.)
                        app.mediator.notify(EVENT_NAME__ENTER_FORM__VALID_SUBMIT);
                    } else {
                        // The user is trying to save their entry as a draft.
                        // Submit the form.
                        this.$formElem.submit();
                    }
                }
            }
            this.adjustCardHeightClassBasedOnCardErrors();
        },

        evaluateElement: function ($elem) {
            var formFieldId = this.jdaValidator.configuration.getFormFieldId($elem);
            var messageBagField = this.jdaValidator.getMessageBagForFormField(formFieldId);
            var messageBag = this.jdaValidator.getMessageBag();
            this.jdaValidator.presenter.clearStatus($elem);
            this.jdaValidator.presenter.showStatus($elem, messageBagField);
            this.adjustCardHeightClassBasedOnCardErrors();
        },

        //==========================================================xdiv2====
        // DOM event handlers: Misc
        //===================================================================

        reactToLanguageDropdown: function () {
            if (this.hasAlternativeLanguage()) {
                this.enableMultiLanguage();
            } else {
                this.disableMultiLanguage();
            }
        },

        reactToLanguageBtnGroup: function (val) {
            var val = typeof val !== 'undefined' ? val : this.$formElem.find('.language-btn-group:first input:checked').val();
            if (val == this.defaultLanguageValueForBtnGroup) {
                this.switchToEnglishLanguage();
            } else {
                this.switchToAuxLanguage();
            }
        },

        // This module wraps around an "uploadImagesCaptions" module. When the "uploadImagesCaptions"
        // module fires an event to notify other modules that it has done adjusting
        // input names, ids, and data attributes, (in response to a user reordering the image/caption blocks)
        // it becomes necessary to then also rebase the cached "file input file values" within the validator instance, according to newly
        // arranged HTML attributes. (Files are cached when uploaded to circumvent browser security restrictions
        // around being unable to programatically determine the value of a file input form field.)
        refreshFileCache: function () {

            var scope = this;
            var cachedValues = [];

            // Build array of cached values
            scope.$formElem.find('.image-caption-card').each(function (k, imageCaptionCard) {

                // Get elements
                var $imageCaptionCard = $(imageCaptionCard);
                var $fileInput = $imageCaptionCard.find('input[type=file]');

                // Get old and new indexes
                var lastPosition = $imageCaptionCard.data('last-position');
                var newPosition = k + 1;

                // Get old and new validation names
                var fileInputName = $fileInput.data('validation-name');
                var lastFileInputName = fileInputName.replace(/[0-9]/g, lastPosition);

                // Get cached value via old validation name
                cachedValues[newPosition] = scope.jdaValidator.getCachedValue(lastFileInputName);

                // Remove cached value
                scope.jdaValidator.clearCachedValuesForFormField(lastFileInputName);
            });

            // Reinsert cached values, with new indexes
            scope.$formElem.find('.image-caption-card').each(function (k, imageCaptionCard) {

                // Get elements
                var $imageCaptionCard = $(imageCaptionCard);
                var $fileInput = $imageCaptionCard.find('input[type=file]');

                // Get new index and validation name
                var fileInputName = $fileInput.data('validation-name');
                var newPosition = k + 1;

                // Get cached value
                var cachedValue = cachedValues[newPosition];

                // Cache the value
                scope.jdaValidator.cacheValuesForFormField(fileInputName, cachedValue);
            });
        },

        //==========================================================xdiv2====
        // Mediator event handlers
        //===================================================================

        // None yet

        //==========================================================xdiv2====
        // Module: Multilanguage mode switching
        //===================================================================

        enableMultiLanguage: function () {
            var scope = this;
            var longLanguageCode = $('select[data-validation-name=alternateLanguageCode]').val();
            var languageCode = longLanguageCode.substring(0, 2).toUpperCase();
            $('.language-btn-group').find('.btn-lang-aux .btn-inner').text(languageCode);
            $('.language-btn-group').removeClass('hidden').attr('aria-hidden', 'false');
            Object.keys(auxLanguageValidationRules).forEach(function (fieldName) {
                auxLanguageValidationRules[fieldName].forEach(function (ruleName) {

                    // Set the actual, operative constraint object
                    scope.jdaValidator.constraintBag.setConstraintSeverity(fieldName, ruleName, 'error');

                    // Set the constraint definition object
                    scope.submitConstraints[fieldName].forEach(function (constraintDefinitionObject) {
                        constraintDefinitionObject.severity = 'error';
                    });
                });
            });
        },

        disableMultiLanguage: function () {
            var scope = this;
            scope.switchToEnglishLanguage();
            $('.language-btn-group').ariaHide();
            Object.keys(auxLanguageValidationRules).forEach(function (fieldName) {
                auxLanguageValidationRules[fieldName].forEach(function (ruleName) {

                    // Set the actual, operative constraint object
                    scope.jdaValidator.constraintBag.setConstraintSeverity(fieldName, ruleName, 'ignored');

                    // Set the constraint definition object
                    scope.submitConstraints[fieldName].forEach(function (constraintDefinitionObject) {
                        constraintDefinitionObject.severity = 'ignored';
                    });
                });
            });
        },

        switchToEnglishLanguage: function () {
            var scope = this;
            $('.language-btn-group').find('.btn').removeClass('active').find('input').prop('checked', false);
            $('.language-btn-group').find('.btn-lang-en').addClass('active').find('input').prop('checked', true);
            $('.feedback-group-main').ariaShow();
            $('.feedback-group-aux').ariaHide();
            $('.caption-error-target-main').ariaShow();
            $('.caption-error-target-aux').ariaHide();
        },

        switchToAuxLanguage: function () {
            var scope = this;
            $('.language-btn-group').find('.btn').removeClass('active').find('input').prop('checked', false);
            $('.language-btn-group').find('.btn-lang-aux').addClass('active').find('input').prop('checked', true);
            $('.feedback-group-main').ariaHide();
            $('.feedback-group-aux').ariaShow();
            $('.caption-error-target-main').ariaHide();
            $('.caption-error-target-aux').ariaShow();
        },

        switchLanguageToRevealFirstBadElem: function ($firstBadElem) {
            var $feedbackGroupElem = $firstBadElem.closest('.feedback-group');
            var elemIsForMainLanguage = $feedbackGroupElem.hasClass('feedback-group-main');
            if (elemIsForMainLanguage) {
                this.switchToEnglishLanguage();
            } else {
                this.switchToAuxLanguage();
            }
        },

        // Returns true if the entrant has specified that they are submitting their entry
        // in english + an alternative language. Returns false if just english.
        hasAlternativeLanguage: function () {
            var val = this.$formElem.find('select[name=alternateLanguageCode]').val();
            return !(val == this.defaultLanguageValueForDropdown || (!val));
        },

        //==========================================================xdiv2====
        // Module: General validation rule switching
        //===================================================================

        changeMultiTeamMemberConstraintsSeverity: function (evaluateForm) {
            evaluateForm = typeof evaluateForm !== 'undefined' ? evaluateForm : true;
            var scope = this;
            var value = this.$formElem.find('input[name=entryType]').filter(':checked').val();
            if (typeof value !== 'undefined') {
                if (value == teamVal) {
                    var severity1 = usingSubmitConstraints ? 'error' : 'warning';
                    var severity2 = usingSubmitConstraints ? 'error' : 'ignored';
                    this.jdaValidator.constraintBag.setConstraintSeverity('teamMembers', 'inArray', severity1);
                    this.jdaValidator.constraintBag.setConstraintSeverity('teamMembers', 'unique', severity1);
                    this.jdaValidator.constraintBag.setConstraintSeverity('teamMembers', 'notEqualToField', severity1);
                    this.jdaValidator.constraintBag.setConstraintSeverity('teamMembers', 'minItems', severity2);
                    this.jdaValidator.constraintBag.setConstraintSeverity('teamMembers', 'email', severity2);
                    this.jdaValidator.constraintBag.setConstraintSeverity('teamMembers', 'present', 'error');
                }
                else if (value == individualVal) {
                    this.jdaValidator.constraintBag.setConstraintSeverity('teamMembers', 'minItems', 'ignored');
                    this.jdaValidator.constraintBag.setConstraintSeverity('teamMembers', 'email', 'ignored');
                    this.jdaValidator.constraintBag.setConstraintSeverity('teamMembers', 'present', 'ignored');
                    this.jdaValidator.constraintBag.setConstraintSeverity('teamMembers', 'inArray', 'ignored');
                    this.jdaValidator.constraintBag.setConstraintSeverity('teamMembers', 'unique', 'ignored');
                    this.jdaValidator.constraintBag.setConstraintSeverity('teamMembers', 'notEqualToField', 'ignored');
                }
                else {
                    throw 'Invalid type.';
                }
            }
            if (evaluateForm) scope.evaluateForm(false, false);
        },

        useSaveDraftConstraints: function (evaluateForm) {
            usingSubmitConstraints = false;
            this.jdaValidator.constraintBag.addConstraints(this.saveDraftConstraints, true);
            this.changeMultiTeamMemberConstraintsSeverity(evaluateForm);
            this.$formElem.trigger(EVENT_NAME__ENTER_FORM__CONSTRAINTS_CHANGED);
        },

        useSubmitConstraints: function (evaluateForm) {
            usingSubmitConstraints = true;
            this.jdaValidator.constraintBag.addConstraints(this.submitConstraints, true);
            this.changeMultiTeamMemberConstraintsSeverity();
            this.$formElem.trigger(EVENT_NAME__ENTER_FORM__CONSTRAINTS_CHANGED);
        },

        //==========================================================xdiv2====
        // Module: Async email validation handling
        //===================================================================

        validateTeamMemberInput: function (element) {
            var scope = this;
            var elementId = $(element).attr('id');
            if (emailCheckTimeout[elementId]) {
                clearTimeout(emailCheckTimeout[elementId]);
            }
            var emailValue = $(element).val();
            emailCheckTimeout[elementId] = setTimeout(function () {
                scope.checkIfEmailExists(emailValue, function (exists) {
                    if (exists) {
                        scope.addEmailToListOfValidEmails(emailValue);
                    }
                    scope.evaluateForm(false, false);
                });
            }, 1000);
        },

        // This function is intended to be called on page load.
        // Its purpose is to remove the delay that occurs when hitting 'Submit', which is caused by checking if the email exists with AJAX.
        // Normally this AJAX check happens on key up. (Gated with a timeout).
        // If the user is actually editing a saved draft, it is desirable to remove this wait by pre-emptively 
        // checking all team member email addresses on page load.
        preEmptivelyInspectEmails: function (callback) {
            var scope = this;
            var $inputElems = this.$formElem.find('input[data-validation-name=teamMembers]');
            var tryToRunCallback = function () {
                if (examinedEmails == $inputElems.length && (typeof callback !== 'undefined')) {
                    callback();
                }
            }
            var examinedEmails = 0;
            $inputElems.each(function (k, elem) {
                var $inputElem = $(elem);
                var emailValue = $inputElem.val();
                scope.checkIfEmailExists(emailValue, function (exists) {
                    if (exists) {
                        scope.addEmailToListOfValidEmails(emailValue);
                    }
                    examinedEmails++;
                    tryToRunCallback();
                });
            });
        },

        addEmailToListOfValidEmails: function (emailValue) {
            var scope = this;
            if (allowedEmailValues.indexOf(emailValue) < 0) {
                allowedEmailValues.push(emailValue);
            }
        },

        passAllowedEmailValues: function () {
            var constraint = this.jdaValidator.constraintBag.getConstraint('teamMembers', 'inArray');
            if (constraint) {
                constraint.params.allowedValues = allowedEmailValues;
            }
        },

        getEmailCheckUrl: function (emailValue) {
            var encodedEmail = encodeURIComponent(emailValue);
            var url = helpers.url('umbraco/api/EntrantApi/IsEmailAddressRegisteredAndActive?emailAddress=' + encodedEmail);
            return url;
        },

        checkIfEmailExists: function (value, callback) {
            var checkUrl = this.getEmailCheckUrl(value);
            $.ajax({
                type: "GET",
                url: checkUrl,
                dataType: "json",
                success: function (response) {
                    if (typeof callback == 'function') {
                        callback.call(null, response.result);
                    }
                }
            });
        },

        //==========================================================xdiv2====
        // Module: Misc
        //===================================================================

        // If any of the image / caption cards have errors in them, we need to increase
        // the height of ALL of the cards so that they still display in a nice,
        // sortable grid. Therefore, this method, which adds a class of 'files-have-errors',
        // if there are any visible error message elements present in the entirety of the
        // mod-upload-images-captions wrapper. It is not ideal to reference this module
        // directly, as modules are not supposed to know about each other. However, as
        // it is a simple check and not an event, the tech debt accrued is trivial.
        adjustCardHeightClassBasedOnCardErrors: function () {
            var $icModElem = $('.mod-upload-images-captions');
            if ($icModElem.length) {
                var maxGroupedErrors = 0;
                $icModElem.find('.image-caption-card').each(function (k, imageCaptionCard) {
                    $imageCaptionCardElem = $(imageCaptionCard);
                    thisErrors = $imageCaptionCardElem.find('.context-message-danger:visible').length;
                    maxGroupedErrors = thisErrors > maxGroupedErrors ? thisErrors : maxGroupedErrors;
                });
                if (maxGroupedErrors) {
                    $icModElem.addClass('files-have-errors');
                    $icModElem.attr('data-error-count', maxGroupedErrors);
                } else {
                    $icModElem.removeClass('files-have-errors');
                    $icModElem.attr('data-error-count', 0);
                }
            }
        },

        getEntryOperationType: function (type) {
            return $('#entryPageContainer').data('entry-operation-type');
        },

        lockFormEditing: function () {
            const scope = this;
            const entryPageContainer = document.getElementById("entryPageContainer");
            const entryId = entryPageContainer ? entryPageContainer.getAttribute("data-entry-id") : null;

            var connection = new signalR.HubConnectionBuilder()
                .withUrl("/jda/EntrySubmissionHub")
                .withAutomaticReconnect()
                .configureLogging(signalR.LogLevel.Trace)
                .build();

            // start the WebSocket connection (Signalr)
            connection.start().then(function () {
                // connection is established => call a function on the server
                connection.invoke("CheckForLocksAsync", entryId).catch(function (err) {
                    return console.error("Could not invoke method [CheckForLocks] on signalR connection", err.toString());
                });
            }).catch(function (err) {
                return console.error("could not establish a signalR connection", err.toString());
            });

            // Listen for events sent out by signalr hub/server
            connection.on("NotifyLockedAsync", function (entryLock) {
                scope.hasEditingRights = false;
                const form = document.querySelector(".page-edit-entry form");

                if (form) {
                    let overlay = form.querySelector(".form-lock-overlay");
                    if (!overlay) {
                        overlay = document.createElement("div");
                        overlay.classList.add("form-lock-overlay");
                        overlay.setAttribute("aria-hidden", "true");

                        form.style.position = "relative";
                        form.appendChild(overlay);
                    }

                    let lockNotice = document.getElementById("form-lock-notice");
                    if (!lockNotice) {
                        const section = document.createElement("section");
                        section.classList.add("area", "wrap-main");

                        const container = document.createElement("div");
                        container.classList.add("container");

                        lockNotice = document.createElement("div");
                        lockNotice.id = "form-lock-notice";
                        lockNotice.classList.add("form-lock-notice");
                        lockNotice.setAttribute("role", "alert");

                        container.appendChild(lockNotice);
                        section.appendChild(container);
                        form.parentElement.insertBefore(section, form);
                    }

                    const toast = app.ui.uiPlugins.toast;
                    const lockedTemplate = document.getElementById("lockedMessage")?.innerHTML || "";
                    const lockMessage = helpers.replaceTokens(lockedTemplate, {
                        USER_NAME: entryLock.entrantFullName,
                        USER_EMAIL: entryLock.entrantEmail
                    });

                    toast.fire(lockMessage, 'danger');
                    lockNotice.innerHTML = lockMessage;
                    form.dataset.lockMessage = lockMessage;

                    if (!overlay.dataset.listenerAttached) {
                        let lastToastTime = 0;

                        overlay.addEventListener("click", () => {
                            const now = Date.now();
                            if (now - lastToastTime > 10000) {
                                const msg = form.dataset.lockMessage || "This form is currently locked.";
                                toast.fire(msg, 'danger');
                                lastToastTime = now;
                            }
                        });

                        overlay.dataset.listenerAttached = "true";
                    }

                    form.querySelectorAll("input, textarea, select, button").forEach((el) => {
                        if (el.id === "cancelEntryButton" || el.classList.contains("entry-page-unlock-dialog__button")) {
                            el.disabled = false;
                        }
                        else {
                            el.disabled = true;
                        }
                    });
                    const saveNav = document.querySelector(".save-nav");
                    if (saveNav) {
                        saveNav.querySelectorAll("input, textarea, select, button").forEach((el) => {
                            if (el.id !== "cancelEntryButton") {
                                el.disabled = true;
                            }
                        });
                    }
                }
            });

            connection.on("NotifyUnlockedAsync", function () {
                const dialog = document.getElementById("unlockDialog");
                const stayBtn = document.getElementById("unlockStay");
                const reloadBtn = document.getElementById("unlockReload");

                const entryPageContainer = document.getElementById("entryPageContainer");
                const entryUrl = entryPageContainer ? entryPageContainer.getAttribute("data-entry-url") : null;

                dialog.showModal();

                stayBtn.addEventListener("click", () => {
                    dialog.close();
                    const toast = app.ui?.uiPlugins?.toast;
                    const editingTemplate = document.getElementById("editingWarning")?.innerHTML || "";
                    toast?.fire(editingTemplate, "warning");
                    scope.hasEditingRights = true;
                });

                reloadBtn.addEventListener("click", () => {
                    location.replace(entryUrl); // Uses the location in data-entry-url attribute for example '/en-GB/Entry/521657f0-2e2b-44f4-bf11-4859a8e20162'
                });

                const form = document.querySelector(".page-edit-entry form");
                if (form) {
                    form.querySelectorAll("input, textarea, select, button").forEach((el) => {
                        el.disabled = false;
                    });
                }
                const saveNav = document.querySelector(".save-nav");
                if (saveNav) {
                    saveNav.querySelectorAll("input, textarea, select, button").forEach((el) => {
                        el.disabled = false;
                    });
                }

                const lockNotice = document.getElementById("form-lock-notice");
                if (lockNotice) {
                    const section = lockNotice.closest("section.area.wrap-main");
                    if (section) {
                        section.remove();
                    } else {
                        lockNotice.remove();
                    }
                }

                const overlay = form.querySelector(".form-lock-overlay");
                if (overlay) {
                    overlay.remove();
                }

                connection.invoke("CheckForLocksAsync", entryId).catch(function (err) {
                    return console.error("Could not invoke method [CheckForLocks] on signalR connection", err.toString());
                });
            });
        },

        putLoadIndicatorOnBtn: function ($btn) {
            var scope = this;
            setTimeout(function () {
                if (scope.isSubmitting) {
                    app.helpers.funcs.removeLoadIndicatorFromButton($('#save-nav li'));
                    app.helpers.funcs.addLoadIndicatorToButton($btn);
                }
            }, 100);
        },

        resetForm: function () {

            var inputsToClear = [
                "#what-it-does",
                "#your-inspiration",
                "#how-it-works",
                "#design-process",
                "#how-is-it-different",
                "#future-plans",
                "#awards",
                "#captionInput-1",
                "#captionInput-2",
                "#captionInput-3",
                "#captionInput-4",
                "#captionInput-5",
                "#video-descr-text",
                "#project-name",
                "#project-description",
                "#videoUrlInput",
                "#website"
            ];

            var inputs = $(inputsToClear.join());

            for (var i = 0; i < inputs.length; i++) {
                $(inputs[i]).val('');
            }

            $('input[value=Individual]').prop("checked", true);

            var categoryButtons = $('[name="entryCategories"]');

            for (var i = 0; i < categoryButtons.length; i++) {
                $(categoryButtons[i]).prop('checked', false);
            }

            $("#alternate-language-code").selectedIndex = 0;

            var imageCards = $('.mod-upload-images-captions .image-caption-card-col');

            for (var i = 0; i < imageCards.length; i++) {
                var $card = $(imageCards[i]);
                $card.find('input.id-input').val('');
                $card.find('input.document-id-input').val('');
                $card.find('input.file-input').val('');
                $card.find('.image-caption-card').removeClass('has-image');
                $card.find('.action-delete').attr('aria-hidden', 'true').attr('tabindex', -1);
            }
        },

        saveFormDraft: function () {
            var scope = this;
            const form = document.querySelector(".page-edit-entry form");
            if (!form) return Promise.resolve(false);

            const formData = new FormData(form);
            const name = formData.get('name');

            if (!name) {
                return Promise.resolve("no action");
            }

            formData.delete('ufprt'); // Remove the hidden Umbraco form input field 'ufprt' as this does auto routing through to SurfaceControllers

            return fetch('/Api/EntryDraft/SaveDraft', {
                method: 'POST',
                credentials: 'include',
                body: formData
            })
                .then(response => {
                    if (response.status === 400 || response.status === 401) {
                        return response.json().then(body => {
                            if (body && (body.errorCode === 'ENTRY_READONLY' || body.errorCode === 'ENTRY_EDITDISALLOWED')) {
                                scope.stopAutoSave();
                            }
                            return false;
                        }).catch(() => false);
                    }
                    if (response.status == 401 || response.status == 404) {
                        window.location.reload();
                        return;
                    }
                    else if (!response.ok) {
                        return;
                    }
                    return response.json();
                })
                .catch(err => {
                    console.error('SaveDraft Error', err);
                    scope.showAutoSaveIndicator('failure');
                    return false;
                });
        },

        initAutoSave: function () {
            const scope = this;
            const form = document.querySelector(".page-edit-entry form");

            if (!form) return;

            this.autoSaveIntervalId = setInterval(() => {

                if (!document.hasFocus())
                    return;

                if (!this.hasEditingRights)
                    return;

                if (!autosaveEnabled || filesAreBeingUploaded)
                    return;

                if (this.saveModalIsOpen())
                    return;

                this.disableSubmitUi();

                scope.showAutoSaveIndicator('saving');

                const name = new FormData(form).get('name');

                if (scope.formId === '00000000-0000-0000-0000-000000000000') {
                    scope.updateFormId();
                    return;
                }

                scope.saveFormDraft().then(success => {
                    if (success) {
                        scope.hydrateNewImageIds(success);
                    }
                    if (success === "no action") {
                        return;
                    }
                    if (!success) {
                        scope.showAutoSaveIndicator('failure');
                        return;
                    }
                }).finally(() => {
                    this.enableSubmitUi();
                });
            }, 30000);
        },

        stopAutoSave: function () {
            if (this.autoSaveIntervalId) {
                clearInterval(this.autoSaveIntervalId);
                this.autoSaveIntervalId = null;
            }
        },

        showAutoSaveIndicator: function (state) {
            const indicators = document.querySelectorAll('.autosave-indicator');
            if (!indicators.length) return;

            indicators.forEach(indicator => {
                const messageEl = indicator.querySelector('.autosave-indicator__message');

                if (messageEl) {
                    messageEl.textContent =
                        state === 'failure' ? 'Autosave failed' : 'Draft saving';
                }

                indicator.classList.add('visible');

                clearTimeout(indicator._hideTimer);
                indicator._hideTimer = setTimeout(() => {
                    indicator.classList.remove('visible');
                }, 4000);
            });
        },

        hydrateNewImageIds: function (savedEntry) {
            if (!savedEntry.result.entryDocuments) {
                return;
            }

            for (var i = 0; i < savedEntry.result.entryDocuments.length; i++) {
                var documentIdInput = document.querySelector(`input[value='${savedEntry.result.entryDocuments[i].document.id}']`);

                // Using DOM traversal based on document ID over index as the user may have re-ordered the images.
                var idInput = documentIdInput.parentElement.querySelector(".id-input");

                if (idInput.value) {
                    continue;
                }

                idInput.value = savedEntry.result.entryDocuments[i].id;
            }
        },

        saveModalIsOpen: function () {
            var modal = document.querySelector('#main-modal');
            return modal.style.display == "block";
        }
    };
});
